var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModuleWrapper',{attrs:{"instance":_vm.instance,"backgroundColor":_vm.backgroundColor}},[_c('p',[_vm._v("Modal Header ("+_vm._s(_vm.instance['modalId'])+")")]),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }